// Layout.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ThemeProvider } from './ThemeProvider';

export function Layout({ children }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // First scroll to top
    window.scrollTo(0, 0);

    // Then handle hash links after a short delay to ensure the new page content is rendered
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [pathname, hash]);

  return (
    <ThemeProvider defaultTheme="dark" storageKey="kinetic-guard-theme">
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
